import { CHROMATIC_SHARP } from '@theory/notes';
import { useAppStore } from '@app/store/useAppStore';
import { encodeKeyId, decodeKeyId } from '@util/musicTheory';
import shared from './dropdownShared.module.css';

export function RootDropdown() {
  const keyId = useAppStore((s) => s.selectedKeyId);
  const selectKey = useAppStore((s) => s.selectKey);
  const decoded = keyId ? decodeKeyId(keyId) : null;
  const currentRoot = decoded?.root ?? 'C';
  const currentQuality = decoded?.quality ?? 'major';

  return (
    <select
      className={shared.select}
      value={currentRoot}
      onChange={(e) => selectKey(encodeKeyId(e.target.value, currentQuality))}
      aria-label="Root"
    >
      {CHROMATIC_SHARP.map((n) => (
        <option key={n} value={n}>
          {n}
        </option>
      ))}
    </select>
  );
}
